<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>

    <div style="width:100%; box-sizing:border-box; padding-bottom: 0px; margin-bottom: 20px; display: inline-block;">
      <div style="width:100%; box-sizing:border-box;">
            <div class="igeny_pageheader">
                <div class="igeny_pageheader_col1">
                    <div class="grc_sectionheader" style="margin-top:0px;">
                        <h2 class="painted_header_h2 color3"><span><b>Daganat S.O.S.</b></span></h2>
                    </div>
                </div>
                <div class="igeny_pageheader_col2">
                    <span class="painted_linkbutton2 color4"><span>{{UgyfelNev}}</span></span>
                </div>
            </div>

      </div>
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="IsEnabled==0" v-html="DisabledText">
        
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="(IsEnabled==1)&&(MainStep==0)">
        <div style="width:100%; box-sizing:border-box; text-align:justify;" v-html="MainStep0_infotext">
            
        </div>

        <div class="btncont" style="margin-top:30px;">

            <span @click="GoTo_MainStep(1)" class="painted_linkbutton2 color3"><span>Igénybejelentés<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

        </div>

    </div>



    <div style="width:100%; box-sizing:border-box;" v-show="(IsEnabled==1)&&(MainStep==1)">
      <div style="padding-bottom: 20px; width:100%; box-sizing:border-box;">

        <div class="igeny_pagecontent">

            <div class="StepProgress_cont">
                <GrcStepProgress ref="StepProgress" />
            </div>

            <div class="innerform_cont" v-show="innerform==5">
                <span class="painted_linkbutton2 color4"><span>Igényelt vizsgálat</span></span>
                <br><br>

                <div class="innerform_col50">

                    <div class="longlabel" style="margin-bottom:20px;">
                        Kérjük adja meg milyen vizsgálatot szeretne igénybe venni?
                    </div>

                    <table style="width:100%; margin-bottom:10px;" cellspacing="0" cellpadding="0">
                    <tr v-for="(ellcsopitem, ellcsopindex)  in ELLATASCSOPORT" v-bind:key="ellcsopindex">
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkEllCsop" v-on:valuechanged="chkEllCsopChanged(ellcsopindex)" :grc_readonly="ellcsopitem.Engedelyezett==1?'false':'true' " />
                        </td>
                        <td valign="top" :class="[ellcsopitem.Engedelyezett==1 ? 'ellcsop_jarobeteg_megnev' : 'ellcsop_jarobeteg_megnev_disabled']">
                            {{ellcsopitem.Megnevezes}}<span class="btnEllCsopInfo" v-show="ellcsopitem.Engedelyezett!=-10" @click="btnEllCsopInfo_click(ellcsopitem.ID)"><i class="fas fa-info-circle"></i></span>
                        </td>
                    </tr>
                    </table>

                </div>
                <div class="innerform_col50">
                    <div class="VizsgalatInfoText" v-html="VizsgalatInfoText" v-show="VizsgalatInfoText!=''"></div>
                </div>

                <div class="longlabel" style="margin-top:20px;">{{txtVizsgalatLeiras_labeltext}}</div>
                <GrcTextArea ref="txtVizsgalatLeiras"
                grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" 
                grc_areaheight="150px"
                style="margin-top:10px;"
                />


                <div class="btncont" style="margin-top:30px;">

                    <span @click="GoTo_MainStep(0)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

                </div>


            </div>




            <div class="innerform_cont" v-show="innerform==10">
                <span class="painted_linkbutton2 color4"><span>Panaszok leírása</span></span>
                <br><br>

                <div class="longlabel">
                    Panaszok kezdete:
                    <br><span style="font-weight:normal;">(az az időpont, amikor először tapasztaltam magamon a tüneteket ezzel a betegséggel kapcsolatban)</span>
                </div>
                <GrcDate ref="txtPanaszokKezdete" v-model="PanaszokKezdete" grc_dateformat="ymd" grc_sep="." 
                grc_labeltext="&nbsp;" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('txtPanaszLeiras');"
                v-on:dropdownopened="SetPopupRef('txtPanaszokKezdete')"
                v-on:dropdownclosed="SetPopupRef('')"
                style="max-width:300px;"
                />

                <GrcTextArea ref="txtPanaszLeiras"
                grc_labeltext="Panaszok rövid leírása (min. 30 karakter):" grc_labelmode="above" grc_labelwidth="200px" 
                grc_areaheight="150px"
                style="margin-top:20px;"
                />


                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(5)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(20)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>


                </div>
            </div>


            <div class="innerform_cont" v-show="innerform==20">
                <span class="painted_linkbutton2 color4"><span>Beutalók, orvosi javaslatok feltöltése</span></span>
                <br><br>

                    <div style="width:100%; box-sizing:border-box; margin-top: 20px;">
                        <div class="docs_label">- Orvosi dokumentáció, javaslat -</div>
                        <GrcDocMultiSelect ref="docs" :grc_allowed_extensions="AllowedExtensions" :grc_maxfiles="MaxFiles" :grc_shownoti="ShowNoti" />
                    </div>
   

                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(40)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>


            <div class="innerform_cont" v-show="innerform==40">
                <span class="painted_linkbutton2 color4"><span>Időpontok megadása</span></span>
                <br><br>

                <div class="infotext" style="margin-bottom:10px;">

                    <div class="general_infotext" style="margin:10px 0px; text-align:justify;">
                        Adjon meg legalább 5 különböző napot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                        Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                        Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 2. nap lehet.
                    </div>

                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 10px; font-weight:500;" >
                    <span class="painted_linkbutton2 color4"><span><i class="fal fa-calendar-alt" style="margin-right:10px;"></i>Időpontok listája</span></span>
                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 20px;" v-show="Idopontok.length==0&&IdopontInputMode==0">
                    A lista még üres
                </div>

                <div class="idopont_cont" v-show="Idopontok.length>0">
                    <div class="idopont_item" v-for="(idopont, idopontindex) in Idopontok">
                        <table class="idopont_item_text" cellspacing="0" cellpadding="0">
                            <tr>
                                <td>
                                    <span style="margin-right:20px;">
                                        {{idopont.DatumTol}} - {{idopont.DatumIg}}
                                    </span>
                                    <span>
                                        {{idopont.TimeTol}} - {{idopont.TimeIg}}
                                    </span>
                                </td>
                                <td style="width:30px; text-align:center; cursor:pointer; color:red;" @click="IdopontTorles(idopontindex)">
                                    <i class="far fa-times-circle"></i>
                                </td>

                            </tr>
                        </table>
                    </div>
                </div>

                <div class="btncont" style="text-align: center; margin: 10px 0px;" v-show="IdopontInputMode==0">
                    <span @click="btnIdopont_Uj_click" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-plus' style="margin-right:10px;"></i>Új időpont hozzáadás</span></span>
                </div>


                <div ref="IdopontInput" class="UjIdopont_cont" v-show="IdopontInputMode>0">

                    <div class="IdopontInput_row">
                
                        <GrcDate ref="txtDatumTol" v-model="txtDatumTol" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Kezdő dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('txtDatumIg');"
                        v-on:dropdownopened="SetPopupRef('txtDatumTol')"
                        v-on:onlydropdownclosed="txtDatumTol_OnInput"
                        
                        class="UjIdopont_mezo"
                        />

                        <GrcDate ref="txtDatumIg" v-model="txtDatumIg" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Záró dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeTol');"
                        v-on:dropdownopened="SetPopupRef('txtDatumIg')"
                        v-on:onlydropdownclosed="txtDatumIg_OnInput"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="IdopontInput_row">

                        <GrcCombo ref="cboTimeTol" v-model="TimeTol" grc_labeltext="Kezdő időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeTol')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeIg');"
                        class="UjIdopont_mezo"
                        />

                        <GrcCombo ref="cboTimeIg" v-model="TimeIg" grc_labeltext="Záró időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeIg')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="btncont" style="margin-top:30px;">

                        <span @click="btnIdopontMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Hozzáadás</span></span>

                        <span @click="btnIdopontMegsem" class="painted_linkbutton2 color7" style="margin:4px;"><span>Mégsem</span></span>

                    </div>

                </div>
    

                <div class="btncont" style="margin-top:50px;" v-show="IdopontInputMode==0">

                    <span @click="btnStepTo(20)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(50)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>



            <div class="innerform_cont" v-show="innerform==50">
                <span class="painted_linkbutton2 color4"><span>Áttekintés és mentés</span></span>
                <br><br>


                <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="text-align:center; font-weight:500; font-size:20px;">{{Osszesito.Igenylo}}</td>
                    </tr>
                    <tr>
                        <td style="text-align:center;padding-top: 10px;"><i>- igénybejelentése -</i></td>
                    </tr>
                </table>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Panaszok kezdete: <span style="font-weight:normal;">{{Osszesito.PanaszKezdet}}</span>
                </div>


                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Panaszok rövid leírása:
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.PanaszLeiras"></div>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Milyen vizsgálatot szeretne a biztosítása terhére igénybe venni?
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.VizsgalatLeiras"></div>


                <div class="osszesito_box_cont">

                        <div class="osszesito_box_col">
                            <div class="osszesito_box_col_header">Idősávok listája:</div>
                            <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; padding-left:10px;" v-html="Osszesito.Idosavok"></div>
                        </div>

                        <div class="osszesito_box_col">
                            <div class="osszesito_box_col_header">Feltöltendő fájlok:</div>

                            <div class="osszesito_box_col_content" v-show="Files.length==0">Nem választott ki fájlt</div>

                            <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left;" v-show="Files.length>0">
                                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; padding-left:10px;"
                                v-for="(fileitem, fileindex) in Files">{{fileitem.FileName}}</div>
                            </div>
                        </div>

                </div>




                
    

                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(40)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Mentés</span></span>

                </div>
            </div>


        </div> <!-- igeny_pagecontent -->

      </div>
    </div>





    
    </div>
</template>

<script>
import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcTajszam from '../GrcComponents/GrcTajszam.vue'
import GrcIrszam from '../GrcComponents/GrcIrszam.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcStepProgress from '../GrcComponents/GrcStepProgress.vue'
import GrcAutoComplete from '../GrcComponents/GrcAutoComplete.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'

export default {
  name: 'frmdaganat_sos_igenyles',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      GrcDate,
      GrcTajszam,
      GrcIrszam,
      GrcTextArea,
      GrcStepProgress,
      GrcAutoComplete,
      GrcDocDisplayer,
      GrcDocMultiSelect,

  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDaganatSOS_Igenyles_",
          UgyfelID:0,
          UgyfelNev:"",
          innerform:-1,

          txtVizsgalatLeiras_labeltext:"Kérjük szövegesen is írja le milyen vizsgálatot igényel?",

          EllCsopSelectedIndex:-1,
          IsEnabled:-1,
          DisabledText:"",

          VizsgalatInfoText:"",
          
          MinPanaszKezdet:"",
          MaxPanaszKezdet:"",
          DokumentumKotelezo:0,

          PanaszokKezdete:"",


          Files: [],
          MaxWidth:1000,
          MaxHeight:1500,
          MaxFileCount:10,

          txtDatumTol:"",
          txtDatumIg:"",
          TimeTol:0,
          TimeIg:0,

          IdopontInputMode:0,
          Idopontok:[],

          Osszesito: { Igenylo:"", PanaszKezdet:"", PanaszLeiras:"", VizsgalatLeiras:"", Idosavok:"" },

        ELLATASCSOPORT:[],

        AllowedExtensions:"pdf, jpg, png",
        ShowNoti:"false",
        MaxFiles:"-1",

        MinDate: "",
        MaxDate:"",

        MainStep:0,
        MainStep0_infotext:"",
        
      }
  },
  model: {
  },  
  methods:{

    GoTo_MainStep(pValue)
    {
        this.MainStep = pValue;
        this.scrollToTop();
    },

    async btnEllCsopInfo_click(pID)
    {
        //console.log(pID);
        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sSelectedEll: ""+pID,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmDaganatSOS_Igenyles_GetVizsgalatInfoText", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), Q.RESULT[0].InfoText);             
        p.height = 500;
        p.width = 600;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },

    txtDatumTol_OnInput(pNewValue)
    {
        this.SetPopupRef('');
        var MD = this.MinDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumIg.SetMinMaxDate(MD, this.MaxDate);

        //console.log("tol: "+pNewValue);
    },

    txtDatumIg_OnInput(pNewValue)
    {
        this.SetPopupRef('');

        var MD = this.MaxDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, MD);

        //console.log("ig: "+pNewValue);
    },


    async chkEllCsopChanged(pIndex)
    {
        if (this.$refs.chkEllCsop[pIndex].GetValue() == 0)
        {
            if (this.EllCsopSelectedIndex != pIndex) { return; }
            else
            {
                this.EllCsopSelectedIndex = -1;
                this.VizsgalatInfoText = "";
                return;
            }
        }

        this.EllCsopSelectedIndex = pIndex;

        for(let i=0; i<this.ELLATASCSOPORT.length; i++)
        {
            if (i != pIndex)
            {
                this.$refs.chkEllCsop[i].SetValue(0);
            }
        }

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sSelectedEll: ""+this.ELLATASCSOPORT[pIndex].ID+",",
        };

        var Q;
        await this.$refs.GRCDB.GetData("frmDaganatSOS_Igenyles_GetVizsgalatInfoText", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            //this.$refs.GRCDB.HideLoading();
            return;
        }

        this.VizsgalatInfoText = Q.RESULT[0].InfoText;

    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmDaganatSOS_Igenyles", pCompName);
    },

    SetLang()
    {
        this.MainStep0_infotext = this.GetTextBookItem("MainStep0_infotext");

    },

      SetControlToFocus(pNextComp)
      {
          if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },


    btnIdopont_Uj_click()
    {
        this.$refs.txtDatumTol.SetText("");
        this.$refs.txtDatumIg.SetText("");
        this.$refs.cboTimeTol.SetValue(0);
        this.$refs.cboTimeIg.SetValue(0);
        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.IdopontInputMode = 1;
    },

    btnIdopontMentes()
    {
        if ((this.$refs.txtDatumTol.GetText() == "")||(this.$refs.txtDatumIg.GetText() == ""))
        {
            this.ShowResult("A dátumok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.txtDatumTol.IsValid(false) == false)
        {
            this.ShowResult("A kezdő dátum helytelen!", 200);
            return;
       }

        if (this.$refs.txtDatumIg.IsValid(false) == false)
        {
            this.ShowResult("A záró dátum helytelen!", 200);
            return;
       }

        if ((this.$refs.cboTimeTol.GetValue() == 0)||(this.$refs.cboTimeIg.GetValue() == 0))
        {
            this.ShowResult("Az időpontok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.cboTimeIg.GetValue() - this.$refs.cboTimeTol.GetValue() < 6)
        {
            this.ShowResult("Kérjük legalább 3 órás időszakot adjon meg!", 200);
            return;
        }



        var DTOL = this.$refs.txtDatumTol.GetText();
        var DIG = this.$refs.txtDatumIg.GetText();

        var TTOL = this.$refs.cboTimeTol.GetText();
        var TIG = this.$refs.cboTimeIg.GetText();


        if (DTOL.localeCompare(DIG) == 1)
        {
            this.ShowResult("A dátumok megadása helytelen!", 200);
            return;
        }

        if (TTOL.localeCompare(TIG) == 1)
        {
            this.ShowResult("Az időpontok megadása helytelen!", 200);
            return;
        }


        var idopontitem = { DatumTol: DTOL, DatumIg: DIG, TimeTol: TTOL, TimeIg: TIG, TimeTolID: this.$refs.cboTimeTol.GetValue(), TimeIgID: this.$refs.cboTimeIg.GetValue()};

        this.Idopontok.push(idopontitem);


        this.IdopontInputMode = 0;
    },

    btnIdopontMegsem()
    {
        this.IdopontInputMode = 0;
    },

    IdopontTorles(pIndex)
    {
        this.Idopontok.splice(pIndex,1);
    },



      HideErrors()
      {
          this.$refs.txtPanaszokKezdete.HideError();
      },



      async btnStepTo(pStepIndex)
      {
          //console.log("from: "+this.innerform+"  to: "+pStepIndex);

          this.HideErrors();

          //pStepIndex = 4;
          if ((this.innerform == 5)&&(pStepIndex==10))
          {
              this.DokumentumKotelezo = 1;

              var step5_EllOK = false;

              for(var i=0; i<this.ELLATASCSOPORT.length; i++)
              {
                  if (this.$refs.chkEllCsop[i].GetValue() == 1)
                  {
                      step5_EllOK =true;
                  }
              }


              if (step5_EllOK == false)
              {
                this.ShowResult("Legalább egy vizsgálat kiválasztása kötelező!", 200);
                return;
              }

            var VL = this.$refs.txtVizsgalatLeiras.GetText();
            VL = VL.replace(/(\r\n|\n|\r)/gm, "");

            if (VL.length < 6)
            {
                this.ShowResult(this.txtVizsgalatLeiras_labeltext, 200);
                return;
            }


          } // from 5 to 10


          if ((this.innerform == 10)&&(pStepIndex==20))
          {
            var ErrorCompName = "";

            var PK = this.$refs.txtPanaszokKezdete.GetText();

            //if ((moment(PK,"YYYY.MM.DD").isValid() == false )||(PK.length!=10))
            if (this.$refs.txtPanaszokKezdete.IsValid(false) == false)
            {
                if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdő dátuma nincs megadva vagy helytelen!");
            }
            else
            {
                if (PK.localeCompare(this.MinPanaszKezdet) == -1)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                    this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdete nem lehet kisebb "+this.MinPanaszKezdet+" napnál!");
                }
                if (PK.localeCompare(this.MaxPanaszKezdet) == 1)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                    this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdete nem lehet nagyobb "+this.MaxPanaszKezdet+" napnál!");
                }
            }

            if (ErrorCompName != "")
            {
                this.SetControlToFocus(ErrorCompName);
                return;
            }

            var PL = this.$refs.txtPanaszLeiras.GetText();
            PL = PL.replace(/(\r\n|\n|\r)/gm, "");

            if (PL.length < 30)
            {
                this.ShowResult("Kérjük röviden írja le panaszát!", 200);
                return;
            }

            this.innerform = 20;
          }

          if ((this.innerform == 20)&&(pStepIndex==40))
          {

              if (this.$refs.docs.GetFileCount() == 0)
              {
                  if (this.DokumentumKotelezo == 1)
                  {
                    this.ShowResult("Legalább egy dokumentum feltöltése kötelező!", 200);
                    return;
                  }
              }

              this.innerform = 40;

          }          


          if ((this.innerform == 40)&&(pStepIndex==50))
          {
              if (this.Idopontok.length == 0)
              {
                this.ShowResult("Kérjük adjon meg legalább egy idősávot!", 200);
                return;
              }

              if (await this.CheckIdosavok() == false) { return; }

            this.DisplayOsszesito();

          }          


          if ((this.innerform == 50)&&(pStepIndex==40))
          {
            this.innerform = 40;
            return;
          }

          if ((this.innerform == 40)&&(pStepIndex==20))
          {
            if (this.DokumentumKotelezo == 0)
            {
                this.btnStepTo(10);
                return;
            }
            this.innerform = 20;
          }



        this.innerform = pStepIndex;
        this.scrollToTop();

        var StepProgressValue = 1;

        if (pStepIndex == 5) { StepProgressValue = 1; }
        if (pStepIndex == 10) { StepProgressValue = 2; }
        if (pStepIndex == 20) { StepProgressValue = 3; }
        if (pStepIndex == 30) { StepProgressValue = 4; }
        if (pStepIndex == 35) { StepProgressValue = 4; }
        if (pStepIndex == 40) { StepProgressValue = 4; }
        if (pStepIndex == 50) { StepProgressValue = 5; }

        this.$refs.StepProgress.SetValue(StepProgressValue);
      },

      DisplayOsszesito()
      {
        this.Files = this.$refs.docs.GetFileNames();

        this.Osszesito.Igenylo = this.UgyfelNev;

        var PL = this.$refs.txtPanaszLeiras.GetText();
        PL = PL.replace(/(\r\n)/gm, "<br>");
        PL = PL.replace(/(\n|\r)/gm, "<br>");

        var VL = this.$refs.txtVizsgalatLeiras.GetText();
        VL = VL.replace(/(\r\n)/gm, "<br>");
        VL = VL.replace(/(\n|\r)/gm, "<br>");


        
        VL = VL + " ("+this.ELLATASCSOPORT[this.EllCsopSelectedIndex].Megnevezes
        VL = VL + ")";
        


        this.Osszesito.PanaszKezdet = this.$refs.txtPanaszokKezdete.GetText();
        this.Osszesito.PanaszLeiras = PL;
        this.Osszesito.VizsgalatLeiras = VL;
        
        this.Osszesito.Idosavok = "";

        for(var i=0; i<this.Idopontok.length; i++)
        {
            this.Osszesito.Idosavok = this.Osszesito.Idosavok
            + this.Idopontok[i].DatumTol+" - "+this.Idopontok[i].DatumIg;

            this.Osszesito.Idosavok = this.Osszesito.Idosavok +"&nbsp;&nbsp;&nbsp;"+this.Idopontok[i].TimeTol+" - "+this.Idopontok[i].TimeIg;

            if (i<this.Idopontok.length-1) { this.Osszesito.Idosavok = this.Osszesito.Idosavok + "<br>"; }
        }


        this.innerform = 50;
        this.scrollToTop();
        this.$refs.StepProgress.SetValue(5);


      },


      async Mentes()
      {
          this.$refs.GRCDB.ShowLoading(false);


          var pFajlok = "";

          if (this.$refs.docs.GetFileCount() > 0)
          {
            var UploadRes = await this.$refs.docs.UploadFiles(1);
            if (UploadRes.Success == false) 
            { 
                this.$refs.GRCDB.HideLoading();
                await this.ShowResult("A dokumentum feltöltés előkészítése sikertelen!", 250);

                return;
            }
            
            pFajlok = pFajlok + "<DOCS>"
            +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
            +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
            +"</DOCS>";

            pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";

          } // ha van fajl

         
          var pIdosavok = this.GetIdosavXml();
          

        //this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sPanaszKezdet: this.Osszesito.PanaszKezdet,
          sPanaszLeiras: this.Osszesito.PanaszLeiras,
          sVizsgalatLeiras: this.Osszesito.VizsgalatLeiras,
          sFajlok: pFajlok,
          sIdosavok: pIdosavok,
          sEllatasIDS: ""+this.ELLATASCSOPORT[this.EllCsopSelectedIndex].ID+",",

        };
        var Q;
        await this.$refs.GRCDB.GetData("frmDaganatSOS_Igenyles_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].strResult, 350).then(res => 
        { 
            if (Q.RESULT[0].intResult == 1)
            {
                document.location = "dashboard";
            }
        });               

      },

      GetFajlXml()
      {
        if (this.Files.length == 0) { return ""; }

        var res = "<NewDataSet>";
        for(var i=0; i<this.Files.length; i++)
        {
            var ext = grcmain_getFileExtension(this.Files[i].filename.toLowerCase());
            if (ext == "jpeg") { ext = "jpg"; }

            res = res 
            +"<FAJL>"
            + "<FajlNev>"+this.Files[i].filename+"</FajlNev>"
            + "<FajlAdat>"+this.Files[i].ResizedData+"</FajlAdat>"
            + "<Kiterjesztes>"+ext+"</Kiterjesztes>"
            +"</FAJL>";
        }
        res = res + "</NewDataSet>";

        return res;
      },




      GetIdosavXml()
      {
        var res = "<NewDataSet>";
        for(var i=0; i<this.Idopontok.length; i++)
        {
            res = res 
            +"<IDOSAV>"
            + "<DatumTol>"+this.Idopontok[i].DatumTol+"</DatumTol>"
            + "<DatumIg>"+this.Idopontok[i].DatumIg+"</DatumIg>"
            + "<IdoTol>"+this.Idopontok[i].TimeTol+"</IdoTol>"
            + "<IdoIg>"+this.Idopontok[i].TimeIg+"</IdoIg>"
            +"</IDOSAV>";
        }
        res = res + "</NewDataSet>";

        return res;
      },

      async CheckIdosavok()
      {
          var res = true;

          var pIdosavok = this.GetIdosavXml();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sIdosavok: pIdosavok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmDaganatSOS_Igenyles_CheckIdosavok", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            res = false;
        }

        this.$refs.GRCDB.HideLoading();

        return res;
      },





      btnMentes()
      {
          this.Mentes();
      },


      async Init()
      {
        this.DokumentumKotelezo = 0;
 

        //this.$refs.StepProgress.Init([ {text:"Panaszok"}, {text:"Orvosi dokumentumok feltöltése"}, {text:"Hely és időpont megadása"}, {text:"Áttekintés"} ]);
        this.$refs.StepProgress.Init([ {text: "Igényelt vizsgálat"},  {text:"Panaszok"}, {text:"Orvosi dokumentumok feltöltése"}, {text:"Időpont megadása"}, {text:"Áttekintés"} ]);
        

        
        this.UgyfelID = gDashboardUgyfelID;


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmDaganatSOS_Igenyles_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.UgyfelNev = Q.RESULT[0].UgyfelNev;
        
        if (Q.RESULT[0].IsEnabled == 0)
        {
            this.IsEnabled = 0;
            this.DisabledText = Q.RESULT[0].DisabledText;
            return;
        }

        this.IsEnabled = Q.RESULT[0].IsEnabled;

        this.ELLATASCSOPORT = Q.ELLATASCSOPORT;

        
        this.MinPanaszKezdet = Q.RESULT[0].MinPanaszKezdet;
        this.MaxPanaszKezdet = Q.RESULT[0].MaxPanaszKezdet;

        this.$refs.cboTimeTol.SetDataSource(Q.IDOPONTOK);
        this.$refs.cboTimeIg.SetDataSource(Q.IDOPONTOK);

        this.MinDate = Q.RESULT[0].MinDate;
        this.MaxDate = Q.RESULT[0].MaxDate;

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        

        this.innerform = 5;


      },


    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },


  },
  created()
  {

  },
  mounted()
  {
    if (gAppInitDone)
    {
      this.SetLang();
      this.Init();
    }
  }

}


</script>


<style scoped>

.igenypage_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    margin-bottom: 20px;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-left: 10px;
}


.innerform_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px;
}

.innerform_col50
{
    width:50%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px 0px;
    vertical-align: top;
    display:inline-block;
}



.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 8px 8px;
    background-color: var(--premblue);
    color: #fff;    
    margin-bottom:20px;
    border-radius: 3px;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.StepProgress_cont
{
    width:100%;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:0px 8px;
}

.igeny_pageheader
{
    width:100%;
    box-sizing: border-box;
    margin-top:10px;
}

.igeny_pageheader_col1
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.igeny_pageheader_col2
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    text-align: right;
    padding-right: 8px;
    padding-top:30px;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}




.filelist_cont {
    width: 100%;
    box-sizing: border-box;
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    color:var(--premblue);
    display: inline-block;
    border-bottom: solid 0px #ccc;
    padding-bottom: 4px;
    margin-bottom: 4px;
    text-align: center;
}

.file_for 
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border:solid 1px #ccc;
    border-radius: 2px;
    margin:5px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    position: relative;
}

.file_for:hover
{
    background-color: #f6f6f6;
}

.file_thumb
{
    width: 100%;
    cursor:pointer;
    text-align: center;
    padding: 5px;
    width:300px;
    height:220px;
    position: relative;
}

.file_footer
{
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    border-top:solid 1px #ccc;
    height: 40px;
    padding:4px;
}

.file_filename
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_filesize
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_delete
{
    width:30px;
    background-color: var(--premblue);
    color: #fff;
    position:absolute;
    right:-1px;
    top:-1px;
    text-align: center;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor:pointer;
    z-index: 500;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.file_delete:hover
{
    background-color: var(--premgreen);
}

.UjIdopont_cont
{
    width: 100%;
    box-sizing: border-box;
    max-width: 600px;
    margin: 0px auto;
    padding: 4px;
    border: solid 1px #ccc;
    -webkit-box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    background-position: 0px 22px;
    border-radius: 3px;    
}

.UjIdopont_mezo
{
    width:50%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 5px;    
}

.infotext
{
    width:100%;
    box-sizing: border-box;
}

.idopont_cont
{
    width:100%;
    box-sizing: border-box;
}

.idopont_item
{
    width:100%;
    box-sizing: border-box;
    padding: 8px 4px;
    border:solid 1px #ccc;
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;    
    -webkit-box-shadow: #ddd 2px 2px 4px;
    box-shadow: 2px 2px 4px #ddd;    
}

.idopont_item:hover
{
    background-color: #f0f0f0;
}

.idopont_item_text
{
    width:100%;
}

.idopont_checkbox_cont
{
    width:100%;
    box-sizing: border-box;
    max-width: 2000px;
    margin-left: auto;
    margin-right: auto;
}

.igeny_pagecontent
{
    width:100%;
    box-sizing: border-box;
    margin: 0px auto;
}

.longlabel
{
    box-sizing: border-box;
    font-family: "CmsDefault", Verdana;
    font-size: 14px;
    line-height: 18px;
    color: #222;
    font-weight: bold;
    width:100%;    
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
}

.IdopontInput_row
{
    width:100%;
    box-sizing: border-box;
    max-width: 600px;
    margin:0px auto;
}

.idopont_list_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-bottom: 10px;
    width:100%;
    max-width: 600px;
}


.osszesito_box_cont
{
    width:100%;
    box-sizing: border-box;
}

.osszesito_box_col
{
    width:50%;
    box-sizing: border-box;
    margin:0px;
    padding: 10px 10px 10px 0px;
    display:inline-block;
    vertical-align: top;
}

.osszesito_box_col_header
{
    width:100%;
    box-sizing: border-box;
    font-weight: 500;
}

.osszesito_box_col_content
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
}


.igenyles_longlabel
{
    width:100%;
    box-sizing: border-box;
    font-weight: bold;
    font-size:13px;
    line-height: 16px;;
}


.ellcsop_jarobeteg_megnev
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#222;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.ellcsop_jarobeteg_megnev_disabled
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#ccc;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.VizsgalatInfoText
{
    width:100%;
    box-sizing: border-box;
    padding: 4px;
    border: solid 1px #ccc;
    border-radius: 3px;
    background-color: #f3f4f5;
    color: #222;
    font-size: 14px;
    line-height: 18px;    
    text-align: justify;
}

>>>.VizsgalatInfoText_Header
{
    font-size: 15px;
    line-height: 15px;
    font-weight: 500;
    color: var(--themecolor3);
    padding: 6px 6px 4px 0px;
    border-radius: 3px;
    margin: 4px 0px;    
    display:inline-block;
    box-sizing: border-box;
}

.docs_label
{
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    color: #222;    
}

.btnEllCsopInfo
{
    font-size: 15px;
    line-height: 15px;
    color: var(--premblue);
    padding: 6px 6px 4px 6px;
    margin-left:0px;
    cursor:pointer;
}

.btnEllCsopInfo:hover
{
    color: var(--premgreen);
}


@media (max-width:800px)
{
    .innerform_cont
    {
        padding:0px;
    }

    .igeny_pageheader_col1
    {
        width:100%;
    }

    .igeny_pageheader_col2
    {
        width:100%;
        text-align: left;
    }

}

@media (max-width:670px)
{
    .filelist_cont
    {
        text-align: center;
    }

    .osszesito_box_col
    {
        width:100%;
        margin-bottom:10px;
    }

    .innerform_col50
    {
        width:100%;
    }

}



</style>